// TODO change when the validation rules are clear
export const EMBROIDERY_MIN_FONT_SIZE = 12;
export const EMBROIDERY_MAX_COLOR_COUNT = 6;
export const EMBROIDERY_MAX_STITCH_COUNT = 15000;
